/**
 * Node-compatible utils (CommonJS). Used by Logger when running in server/html-package.
 * For TypeScript consumers, use utils.ts.
 */

const config = require("../config.json");

const LABELS = {
  DEV: "Development",
  TEST: "Testing",
  PROD: "Production",
  PIPELINE: "Pipeline",
  UNKNOWN: "Unknown",
};

function requestorIdEnv(requestorClientId) {
  if (
    requestorClientId.includes(".gol.in.") ||
    requestorClientId.includes("docker.in.") ||
    requestorClientId.endsWith(".devel.golibe.com")
  ) {
    return { key: "DEV", label: LABELS.DEV };
  }
  if (
    requestorClientId.includes("tester") ||
    requestorClientId.includes("gitlab") ||
    requestorClientId.includes("golapi-test")
  ) {
    return { key: "PIPELINE", label: LABELS.PIPELINE };
  }
  if (requestorClientId === "") {
    return { key: "PROD", label: LABELS.PROD };
  }
  return { key: "UNKNOWN", label: LABELS.UNKNOWN };
}

function getEnvironmentFromRequestorClientId() {
  const requestorClientId =
    process.env.NEXT_PUBLIC_D4_requestorClientId ||
    config.requestorClientId ||
    "";

  return requestorIdEnv(requestorClientId);
}

/**
 * Get Sentry environment from domain/hostname
 * Uses the same logic as requestorIdEnv but accepts hostname directly
 * @param {string} hostname - The hostname/domain (e.g., "gitlab-runner.gol-tester06.in.cee-systems.com")
 * @returns {string} Environment label string (e.g., "Pipeline", "Development", "Production")
 */
function getSentryEnvironmentFromHostname(hostname) {
  if (!hostname) {
    return getEnvironmentFromRequestorClientId().label;
  }

  return requestorIdEnv(hostname).label;
}

module.exports = {
  getEnvironmentFromRequestorClientId,
  getSentryEnvironmentFromHostname,
};
